<template>
  <el-container class="PersonnelVehicleInformation">
    <!-- 单位信息 -->
    <el-card class="tree-card" :body-style="treeCard">
      <div class="tree-box">
        <el-card
          :class="{ hoverCard: leftListIndex === index }"
          v-for="(item, index) in leftList"
          :key="index"
          shadow="always"
          @click="leftClick(item, index)"
        >
          <div class="mycard">
            <span>
              {{ item.value }}
            </span>
            <span>{{ item.num }}</span>
          </div>
        </el-card>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="任务名称" prop="taskName">
          <el-input
            v-model="tableParams.taskName"
            placeholder="任务名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="任务类型" prop="taskType">
          <h-selectcode
            type="zaxf_task_type"
            v-model="tableParams.taskType"
            placeholder="任务类型"
          ></h-selectcode>
        </el-form-item>
        <el-form-item label="时间" prop="Time">
          <h-date-timerange
            v-model:end="tableParams.endTime"
            v-model:start="tableParams.startTime"
          >
          </h-date-timerange>
        </el-form-item>
        <el-form-item label="状态" prop="taskDetailsState">
          <h-selectcode
            type="zaxf_task_details_state"
            v-model="tableParams.taskDetailsState"
            placeholder="任务状态"
          ></h-selectcode>
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable()">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
        <el-row>
          <el-col>
            <h-button type="danger" @click="delUser">删除</h-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="defenderList"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #taskDescribe="{ row }">
            <span v-text="row.taskDescribe"></span>
          </template>
        </h-table>
      </div>
    </el-card>
    <el-dialog v-model="formVisible" title="巡防任务详情" width="70%">
      <taskListDetail
        v-if="formVisible"
        :from="userFormData"
        :occupationList="occupationList"
      ></taskListDetail>
    </el-dialog>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { getDict } from "@/api/constant";
import moment from "moment";
import { formatDateHMS } from "@/utils/index.js";
import taskListDetail from "./components/taskListDetail.vue";
import {
  defenderList,
  taskCount,
  taskDetailsDetele,
} from "@/api/prevention/prevention.js";

import { handledutyDetail } from "@/api/communityCare/communityCareApi.js";

import _ from "lodash";
export default defineComponent({
  name: "",
  components: { taskListDetail },
  props: {},
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      filterText: "",
      rootNodeKey: "",
      Time: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      leftListIndex: 0,
      leftList: [],
      tableParams: {
        taskName: "",
        taskType: "",

        startTime: "",
        endTime: "",
        taskDetailsState: "",
      },
      tableData: [],
      tableSelection: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "任务名称",
          prop: "taskName",
        },
        {
          label: "开始时间",
          prop: "taskStartTimeDict",
        },
        {
          label: "结束时间",
          prop: "taskEndTimeDict",
        },
        {
          label: "任务描述",
          slot: "taskDescribe",
        },

        {
          label: "任务类型",
          prop: "taskTypeDict",
        },
        {
          label: "状态",
          prop: "taskDetailsStateDict",
        },
        {
          type: "operate",
          label: "操作",
          prop: "operate",
          width: "150px",
          operates: [
            { name: "详情", emitKey: "info" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      occupationList: [], //巡防员职业
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);

    // 点击查询按钮
    const refreshTable = () => {
      state.leftListIndex = Number(state.tableParams.taskDetailsState);
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
      state.tableParams.endTime = "";
      state.tableParams.startTime = "";
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = ({ emitKey }, row) => {
      if (emitKey === "info") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
        nextTick(() => {});
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该任务吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteTask([row.taskId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    const clickTable = async (item) => {
      state.userFormData = _.cloneDeep(item);
      state.formStatus = 2;
      state.formVisible = true;
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的任务吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.taskId);
            deleteTask(ids);
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的任务",
        });
      }
    };
    const deleteTask = async (ids) => {
      const res = await taskDetailsDetele(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 左侧
    const getDictAxios = async () => {
      //数据字典
      const res = await getDict("zaxf_occupation");
      state.occupationList = res.dict;
      const resDict = await getDict("zaxf_task_details_state");
      state.leftList = resDict.dict;
      state.leftList.unshift({ code: "", num: 0, value: "全部" });
      statisticsDutyInfoAxios();
    };
    getDictAxios();
    const statisticsDutyInfoAxios = async () => {
      const res = await taskCount({});
      state.leftList.forEach((item, index) => {
        item.num = 0;
        res.data.forEach((element, inde) => {
          if (element.code == item.code) {
            item.num = element.num;
          }
        });
      });
      state.leftList[0].num = state.leftList.reduce(function (prev, cur) {
        return prev + Number(cur.num);
      }, 0);
    };

    const leftClick = (item, index) => {
      state.leftListIndex = index;
      state.tableParams.taskDetailsState = item.code;
      refreshTable();
    };
    const cancel = () => {
      state.formVisible = false;
      refreshTable();
    };
    return {
      ...refData,
      cancel,
      leftClick,
      clickTable,
      refreshTable,
      resetForm,
      hzTableSelect,
      handleClick,
      userSubmit,
      defenderList,
      formRef,
      tableRef,
      delUser,
    };
  },
});
</script>
<style lang="scss" scoped>
.PersonnelVehicleInformation {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .hoverCard {
        // background: red;
        border: 1px solid #3a74fb;
        border-left: 5px solid #3a74fb;
        color: #3a74fb;
      }
      .el-card {
        margin: 10px 0 !important;
        :deep(.el-card__body) {
          display: flex !important;
          justify-content: space-around !important;
          cursor: pointer;
        }
        .mycard {
          display: flex !important;
          justify-content: space-between;
        }
      }
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      img {
        width: 42%;
        height: 90px;
      }
      .table-role {
        color: #294a7c;
        cursor: pointer;

        text-align: center;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
